var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "vue-need-bootstrap h100" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center align-items-center w-100 h-100 gradient-customily-bg",
      },
      [
        _c(
          "b-card",
          [
            _c(
              "b-card-body",
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("img", {
                        staticClass: "center-block",
                        attrs: { src: _setup.customilyImg },
                      }),
                      _vm._v(" "),
                      _setup.username && _setup.token && !_setup.errorMessage
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_setup.emailConfirmed,
                                    expression: "!emailConfirmed",
                                  },
                                ],
                              },
                              [
                                _c("b-card-text", { staticClass: "mt-2" }, [
                                  _vm._v(" Confirming your new email address "),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center mt-2" },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "mr-2",
                                      attrs: { variant: "primary" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _setup.emailConfirmed,
                                    expression: "emailConfirmed",
                                  },
                                ],
                                staticClass: "mt-3",
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_setup.confirmedEmail)),
                                ]),
                                _vm._v(
                                  " was confirmed for your user " +
                                    _vm._s(_setup.confirmedUsername) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_setup.username || !_setup.token
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-card-text",
                                { staticClass: "text-center mt-2" },
                                [_vm._v(" Invalid URL ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.errorMessage
                        ? _c(
                            "div",
                            { staticClass: "text-center mt-2" },
                            [
                              _c("b-card-text", { staticClass: "mb-2" }, [
                                _vm._v(" Error confirming email address "),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-card-text",
                                { staticClass: "error-message" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_setup.errorMessage) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }